
export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    if (sectionId === 'hero') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/0c3b91f5a78bf116a8f1933873ec41d9.png" 
                alt="ローカルマーケティングラボ" 
                className="h-12 w-auto"
              />
              <span className="text-gray-900 font-semibold text-xl">ローカルマーケティングラボ</span>
            </div>
            <p className="text-gray-600 mb-4 max-w-md leading-tight">
              地域に根ざしたマーケティング支援を通して、<br />
              お客様のビジネス成長と成功をサポートしています。
            </p>
            <div className="text-gray-600 text-sm mt-6">
              <p className="font-semibold mb-1">運営会社</p>
              <p className="mb-1">ナインバレー株式会社</p>
              <p>〒753-0056　山口県山口市湯田温泉2丁目4-26</p>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">メニュー</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('hero')}
                  className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                >
                  Top
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('voices')}
                  className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                >
                  Voices
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-8">
          <div className="flex flex-col items-center space-y-2">
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-4">
              <p className="text-gray-600 text-sm">
                © 2025 ローカルマーケティングラボ. All rights reserved.
              </p>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-600 text-sm hover:text-blue-600 transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
